/** @format */
import qs from 'qs';

import { ModelSearchResultsType } from '../constants';
import { Query, SelectedFilters } from '../types';
import { getSortedFilterQueryString } from './helpers';

export function getModelFacetsQueryKey(
    type: ModelSearchResultsType,
    baseQuery: Partial<Query>,
    selectedFilters: SelectedFilters
) {
    const sortedFilterQueryString = getSortedFilterQueryString(selectedFilters);

    const queryKey = [
        'facets',
        type,
        qs.stringify(baseQuery, { arrayFormat: 'comma' }),
        sortedFilterQueryString,
    ];

    return queryKey;
}
